import { ComponentProps } from 'react';

import * as RSlider from '@radix-ui/react-slider';
import { withStyles } from '../../../utils';
import styles from './Slider.module.scss';

const cn = withStyles(styles);

export type SliderProps = ComponentProps<typeof RSlider.Root>;

export default function Slider({ className, ...props }: SliderProps) {
  const value = props.value || props.defaultValue;

  return (
    <RSlider.Root {...props} className={cn('sliderRoot', className)}>
      <RSlider.Track className={cn('sliderTrack')}>
        <RSlider.Range className={cn('sliderRange')} />
      </RSlider.Track>

      {value?.map((_, ii) => <RSlider.Thumb key={ii} className={cn('sliderThumb')} />)}
    </RSlider.Root>
  );
}
